import { getVehicleFilterCollectionV2, SearchVehicleFilterApiParameter, SearchVehicleFilterResponse } from "@dana/Services/VehicleFilterService";
import { SearchVehicleActions } from "@dana/Store/Data/SearchVehicleFilter/Reducers/SearchVehicleReducer";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter, getProductCollectionV2 } from "@insite/client-framework/Services/ProductServiceV2";
import { DispatchProp } from "react-redux";

export interface SearchVehicleFilterParameter {
    year?: string;
    make?: string;
    model?: string;
    engine?: string;
    sortOrder?: string;
}


type HandlerType = ApiHandlerDiscreteParameter<
    SearchVehicleFilterParameter,
    GetProductCollectionApiV2Parameter,
    SearchVehicleFilterResponse,
    DispatchProp<SearchVehicleActions>
>;
export const SetLoadingOn: HandlerType = props => {
    props.dispatch?.({
        type: "SearchVehicle/Filter/IsLoading",
        isLoading: true,
    });
}
export const PopulateApiParameter: HandlerType = props => {
    const { make, model, year, sortOrder } = props.parameter;

    const apiParameter: SearchVehicleFilterApiParameter = {
        make,
        model,
        year,
        sortOrder
    };
    props.apiParameter = apiParameter;
    props.dispatch?.({
        type: "SearchVehicle/Filter/ClearSearch",
        clearSearch: false,
    } as any);
};

export const PopulateVehicleFilterCollection: HandlerType = async props => {
    props.apiResult = await getVehicleFilterCollectionV2(props.apiParameter);
};
export const PopulateFacetResult: HandlerType = props => {

    if (props.apiResult) {
        props.dispatch?.({
            type: "SearchVehicle/Filter/PopulateResult",
            year: props.parameter.year,
            make: props.parameter.make,
            model: props.parameter.model,
            engine: props.parameter.engine,
            filterFacet: props.apiResult?.filterFacet,
        } as any);
    }
}
export const SetLoadingOff: HandlerType = props => {
    props.dispatch?.({
        type: "SearchVehicle/Filter/IsLoading",
        isLoading: false,
    });
}
export const chain = [
    SetLoadingOn,
    PopulateApiParameter,
    PopulateVehicleFilterCollection,
    PopulateFacetResult,
    SetLoadingOff
];

const getVehicleFilters = createHandlerChainRunner(chain, "SearchVehicleHandler");
export default getVehicleFilters;
